// Mock data for cost2build.ai — frontend only
// NOTE: This data is MOCKED. It will be replaced with real backend + AI later.

export const NAV_LINKS = [
  { label: "How it works", href: "#how-it-works" },
  { label: "Estimator", href: "#estimator" },
  { label: "3D Studio", href: "#studio" },
  { label: "Pricing", href: "#pricing" },
];

export const STATS = [
  { value: "38,400+", label: "Estimates run" },
  { value: "50", label: "U.S. states + Canada" },
  { value: "12+", label: "Cost scopes" },
  { value: "< 30s", label: "To first number" },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1706808849780-7a04fbac83ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBob3VzZSUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3ODYzNTA3NTR8MA&ixlib=rb-4.1.0&q=85";

export const BLUEPRINT_IMAGE =
  "https://images.unsplash.com/photo-1721244654346-9be0c0129e36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxibHVlcHJpbnQlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg2MjQxMjMwfDA&ixlib=rb-4.1.0&q=85";

export const AI_3D_IMAGE =
  "https://images.unsplash.com/photo-1624066969616-69b0b0301d4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3R1cmFsJTIwbW9kZWx8ZW58MHx8fHwxNzg2MzUwNzkzfDA&ixlib=rb-4.1.0&q=85";

export const BUILD_TYPES = [
  {
    id: "residential",
    name: "Homes & Apartments",
    blurb: "Custom single-family, ADUs and multi-family units.",
    image:
      "https://images.unsplash.com/photo-1761013320045-d29e4f10bcbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxyZXNpZGVudGlhbCUyMGhvbWV8ZW58MHx8fHwxNzg2MzUwNzU0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "warehouse",
    name: "Warehouses",
    blurb: "Distribution, storage and logistics facilities.",
    image:
      "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHx3YXJlaG91c2UlMjBidWlsZGluZ3xlbnwwfHx8fDE3ODYzNTA3ODZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "commercial",
    name: "Commercial & Office",
    blurb: "Retail fit-outs, offices and mixed-use builds.",
    image:
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxjb21tZXJjaWFsJTIwb2ZmaWNlfGVufDB8fHx8MTc4NjM1MDc4Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "industrial",
    name: "Industrial",
    blurb: "Manufacturing plants and heavy-use facilities.",
    image:
      "https://images.unsplash.com/photo-1584060330377-3fd93ef4e991?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwZmFjaWxpdHl8ZW58MHx8fHwxNzg2MzUwNzg1fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const HOW_IT_WORKS = [
  {
    step: "01",
    title: "Describe your build",
    body: "Pick a building type, size and finish level — or describe your project in plain English and let the AI structure it.",
  },
  {
    step: "02",
    title: "Get AI cost scopes",
    body: "Instant estimates broken down by material and labor for every scope of work, benchmarked to U.S. & Canadian averages.",
  },
  {
    step: "03",
    title: "Save & compare",
    body: "Store every project, re-estimate as prices change, and compare builds side by side in your dashboard.",
  },
];

export const AI_TOOLS = [
  {
    id: "estimator",
    tag: "AI Estimator",
    title: "Contractor-grade cost estimates in seconds",
    body: "Our estimation engine blends regional labor rates, current material pricing and thousands of comparable projects to give you a defensible number — scope by scope.",
    bullets: ["Material vs. labor split", "Per-square-foot benchmarks", "State & province adjustments"],
  },
  {
    id: "assistant",
    tag: "AI Assistant",
    title: "Ask anything about your build",
    body: "Chat with an AI construction advisor that understands your project. Get value-engineering ideas, code considerations and material swaps to hit your budget.",
    bullets: ["Plain-English project chat", "Value-engineering tips", "Budget trade-off analysis"],
  },
  {
    id: "vision",
    tag: "AI Vision",
    title: "Upload a plan. Watch it become 3D.",
    body: "Drop in a floor plan or blueprint — the AI reads the layout, builds an interactive 3D model and renders a photorealistic vision of the finished building.",
    bullets: ["Blueprint reading", "Interactive 3D model", "Photorealistic render"],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "I priced our home addition in three minutes and the scope was accurate enough that our GC used it almost line for line.",
    name: "Marcus Thompson",
    role: "Homeowner · Austin, TX",
  },
  {
    quote:
      "As a small developer I bid jobs across several states. Instant state-adjusted numbers have saved me days of spreadsheet work every month.",
    name: "Priya Nair",
    role: "Developer · Toronto, ON",
  },
  {
    quote:
      "We turned a rough restaurant fit-out idea into a real tenant-improvement budget in minutes. The per-square-foot benchmarks were spot on.",
    name: "Diego Ramirez",
    role: "Restaurateur · Denver, CO",
  },
];

// --- Instant estimator config (MOCK rule-based math) ---
export const COUNTRIES = [
  { code: "US", name: "United States", currency: "USD", symbol: "$" },
  { code: "CA", name: "Canada", currency: "CAD", symbol: "CA$" },
];

export const BUILDING_TYPES = [
  { id: "single_family", name: "Single-Family Home", baseRate: 185 },
  { id: "multi_family", name: "Multi-Family / Apartments", baseRate: 210 },
  { id: "adu", name: "ADU / Garage Conversion", baseRate: 260 },
  { id: "warehouse", name: "Warehouse", baseRate: 95 },
  { id: "commercial", name: "Commercial / Office", baseRate: 230 },
  { id: "industrial", name: "Industrial Facility", baseRate: 145 },
];

export const FINISH_LEVELS = [
  { id: "economy", name: "Economy", mult: 0.82 },
  { id: "standard", name: "Standard", mult: 1.0 },
  { id: "premium", name: "Premium", mult: 1.28 },
  { id: "luxury", name: "Luxury", mult: 1.65 },
];

export const US_REGIONS = [
  { id: "national", name: "National Average", mult: 1.0 },
  { id: "northeast", name: "Northeast", mult: 1.22 },
  { id: "west", name: "West Coast", mult: 1.31 },
  { id: "midwest", name: "Midwest", mult: 0.94 },
  { id: "south", name: "South", mult: 0.9 },
];

export const CA_REGIONS = [
  { id: "national", name: "National Average", mult: 1.0 },
  { id: "ontario", name: "Ontario", mult: 1.18 },
  { id: "bc", name: "British Columbia", mult: 1.27 },
  { id: "alberta", name: "Alberta", mult: 1.05 },
  { id: "quebec", name: "Quebec", mult: 0.98 },
];

export const FOOTER_LINKS = {
  Product: ["Estimator", "AI Assistant", "Blueprint to 3D", "Pricing"],
  Company: ["About", "Careers", "Press", "Contact"],
  Resources: ["Cost guides", "Blog", "Help center", "API"],
  Legal: ["Privacy", "Terms", "Security"],
};
